export const SEARCH_URL = 'https://clinicaltrialskorea.com/studies?condition=';
